import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Label, Row, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import { Get, Delete, JENIS_DESA } from '../../../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import classnames from 'classnames';

import BootstrapTable from 'react-bootstrap-table-next';

import ModalLembaga from "./modal/lembaga";
import ModalProfil from "./modal/profil";
import ModalPerangkat from "./modal/perangkat";
import ModalDetailPerangkat from "./modal/detail-perangkat";
import ModalJabatanPerangkat from "./modal/jabatan-perangkat";
import ModalBidang from "./modal/bidang";

var HtmlToReactParser = require("html-to-react").Parser;

const frmLembaga = {
  uuid: '',
  nama_lembaga: '',
  tahun_berdiri: '',
  status: 'Aktif',
}

const frmPerangkat = {
  uuid: '',
  uuid_lembaga: '',
  uuid_jabatan_lembaga: '',
  uuid_bidang_lembaga: '',
  nama: '',
  status: '1',
  foto: ""
}

const frmJabatanPerangkat = {
  uuid: '',
  uuid_lembaga: '',
  nama: '',
  urutan: '',
}

const frmBidang = {
  uuid: '',
  uuid_lembaga: '',
  nama: '',
}

class BasicTable extends Component {
  _isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
      // DATA LEMBAGA
        dataLembaga:[],
        listDataLembaga:[],
        paginationLembaga: [],
        statusLembaga: {
          form:false,
          btnForm:false,
          btnAksi:false
        },
        awalLembaga: "",
        sebelumLembaga: "",
        halLembaga: [],
        setelahLembaga: "",
        akhirLembaga: "",
        dtLembaga:frmLembaga,
        dataCariLembaga: null,
        uuidLembaga: null,
      // END DATA LEMBAGA
      
      // DATA PERANGKAT LEMBAGA
			dataPerangkat: [],
      listJabatan: [],
			jabatanStat: null,
      listBidang: [],
			bidangStat: null,
			loadingPerangkat: false,
			paginationPerangkat: [],
      statusPerangkat: {
        form:false,
        btnForm:false,
        btnAksi:false,
				select: false
      },
      awalPagePerangkat: "",
      sebelumPagePerangkat: "",
      halPagePerangkat: [],
      setelahPagePerangkat: "",
      akhirPagePerangkat: "",
      dtPerangkat:frmPerangkat,
      judulPerangkat: "Tambah Detail Perangkat",
      detailLembaga: [],
      // Cari Data
      dataCariPerangkat: null,
			uuidLembagaPerangkat: null,
      perangkatDetailStatus: false,
      detailPerangkat: [],
      statusDetailPerangkat: {
        form:false,
        btnForm:false,
        btnAksi:false
      },
      // END DATA PERANGKAT LEMBAGA

      // DATA JABATAN PERANGKAT LEMBAGA
       dataJabatanPerangkat:[],
       loadingJabatanPerangkat: false,
       paginationJabatanPerangkat: [],
       statusJabatanPerangkat: {
         form:false,
         btnForm:false,
         btnAksi:false
       },
       awalJabatanPerangkat: "",
       sebelumJabatanPerangkat: "",
       halJabatanPerangkat: [],
       setelahJabatanPerangkat: "",
       akhirJabatanPerangkat: "",
       dtJabatanPerangkat:frmJabatanPerangkat,
       // Cari Data
       dataCariJabatanPerangkat: null,
      // END JABATAN PERANGKAT DATA LEMBAGA

      // DATA BIDANG LEMBAGA
       dataBidang:[],
       loadingBidang: false,
       paginationBidang: [],
       statusBidang: {
         form:false,
         btnForm:false,
         btnAksi:false
       },
       awalPageBidang: "",
       sebelumPageBidang: "",
       halPageBidang: [],
       setelahPageBidang: "",
       akhirPageBidang: "",
       dtBidang:frmBidang,
       // Cari Data
       dataCariBidang: null,
      // END DATA BIDANG LEMBAGA

      // Profil
      loadingProfil: false,
      statusProfil: {
        form:false,
        btnForm:false,
        btnAksi:false,
				select: false
      },
      judulProfil: "Tambah Profil Lembaga",
      // End Profil

			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false
			},
			input: 'none',
			view: 'inherit',
			judul: 'Tambah Profile',
			alert: null,
			show: false,
			loading: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			
			// Tab Vertical
      active_tab_vertical: 999998,
      active_tab_icon: '1',

		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	// Toggle Vertical Tabs
	toggle_vertical(tab, data) {
    if (this.state.active_tab_vertical !== tab) {
      this.fetchPerangkat(data.uuid, { page: null, where: [] });
      this.fetchJabatanPerangkat(data.uuid, { page: null, where: [] });
      this.fetchBidang(data.uuid, { page: null, where: [] });
      this.refreshProfil(data.uuid);
      this.getDataJabatan(data.uuid);
      this.getDataBidang(data.uuid);
      this.setState({
          detailLembaga: data,
          active_tab_vertical: tab,
          uuidLembaga: data.uuid,
          uuidLembagaPerangkat: data.uuid,
          perangkatDetailStatus:false,
          active_tab_icon: '1',
      });
    }
  }
  
  // Toggle Horizontal tabs
	toggle_icon(tab) {
		if (this.state.active_tab_icon !== tab) {
      this.getDataJabatan(this.state.uuidLembaga);
      this.getDataBidang(this.state.uuidLembaga);
			this.setState({
				active_tab_icon: tab
			});
		}
	}

// ################################################################################################

    // DATA LEMBAGA
      // FETCH DATA LEMBAGA
      fetch = (params = {}) => 
      {    
        this.setState({ loading: true })

        let linkLembaga = "";
        if (params.page)
        {
            switch(params.page)
            {
                case '>>': linkLembaga = "?page="+(Math.ceil(this.state.paginationLembaga.total / this.state.paginationLembaga.per_page));break;
                case '>': linkLembaga = "?page="+(parseInt(this.state.paginationLembaga.current_page) + 1);break;
                case '<': linkLembaga = "?page="+(parseInt(this.state.paginationLembaga.current_page) - 1);break;
                case '<<': linkLembaga = "?page=1";break;
                default: linkLembaga = "?page="+params.page;break;
            }
        }

        let cariLembaga= '';
        if(this.state.dataCariLembaga){
          cariLembaga = '?q='+this.state.dataCariLembaga
        }

        Get('lembaga-kemasyarakatan'+linkLembaga+cariLembaga, null, (dtkat) => {
          if(dtkat.results.data.length === 0){
            this.setState({
              active_tab_vertical: 999998,
              dataLembaga: dtkat.results.data,
              loading: false,
              paginationLembaga:dtkat.results,
            })
          }
          else{
            if (dtkat.results) {
              // if(this.state.active_tab_vertical===1){
                this.setState({
                  // detailLembaga: dtkat.results.data,
                  paginationLembaga:dtkat.results,
                  uuidLembagaPerangkat:dtkat.results.data.uuid
                })
                // this.fetchPerangkat(dtkat.results.data.uuid, { page: null, where: [] });
                this.paginationLembaga(dtkat.results);
              // }
              this.setState({ 
                dataLembaga: dtkat.results.data,
                loading: false
              });
            }
          }
        });
      };

  
      //  PAGINATION LEMBAGA
      paginationLembaga = (data) => {
        let awalLembaga = "";
        let halLembaga = [];
        let sebelumLembaga = "";
        let setelahLembaga = "";
        let akhirLembaga = "";
        if (data.total > 0)
        {
            let start = 1;
            let end = 5;
            let n = 0;
            let p = 0;
            if (data.current_page <= 3)
            {   
                start = 1;
                end = 5;
                if (data.last_page > data.current_page)
                {
                    n = data.current_page + 1;
                }
            }
            else 
            {
                p = data.current_page - 1;
                n = data.current_page + 1;
                start = data.current_page - 2;
                end = data.current_page + 2;
            }
            if (end >= data.last_page - 2)
            {
                p = data.current_page - 1;
                if (start >= 5)
                {
                    start = data.last_page - 4;
                }
                end = data.last_page;
            }

            for (let i=start;i<=end;i++) 
            {
                let warna = "primary-custom";
                if (i === data.current_page)
                {
                    warna = "danger"
                }
                halLembaga.push(<a href={() => false} onClick={()=>this.fetch({page:i})} className={"btn btn-"+warna+" btn-square btn-sm pr-3 pl-3 pt-2 pb-2"}>{i}</a>)
            }
            if (p > 0)
            {
                sebelumLembaga = (<a href={() => false} onClick={()=>this.fetch({page:p})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<"}</a>)
            }
            if (n > 0)
            {
                setelahLembaga = (<a href={() => false} onClick={()=>this.fetch({page:n})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">"}</a>)
            }
            awalLembaga = (<a href={() => false} onClick={()=>this.fetch({page:1})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<<"}</a>)
            akhirLembaga = (<a href={() => false} onClick={()=>this.fetch({page:data.last_page})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">>"}</a>)
        }
        this.setState({awalLembaga,sebelumLembaga,halLembaga,setelahLembaga,akhirLembaga});
      }

      // TOMBOL AKSI DATA LEMBAGA
      tombolAksiLembaga = (cell, row) => {
        return (
          <>
              {/* <Button  size="xs" color="btn btn-secondary" className="btn-icon" onClick={() => this.detailDataLembaga(row)} disabled={this.state.statusLembaga.btnAksi}><i className="fa fa-eye"></i></Button> <br/> */}
              <Button  size="xs" color="success" className="btn-icon" onClick={() => this.ubahDataLembaga(row)} disabled={this.state.statusLembaga.btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;&nbsp;
              <Button  size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapusLembaga(row.uuid)} disabled={this.state.statusLembaga.btnAksi}><i className="fa fa-trash"></i></Button>  
          </>
        )
      }

      // BUKA FORM LEMBAGA
      bukaFormLembaga = () => {
        this.setState({
            statusLembaga:{
                ...this.state.statusLembaga,
                form: true,
            }
        })
        this.forceUpdate();
      }

      // TAMBAH DATA LEMBAGA
      tambahDataLembaga = e => {
        this.setState({
          statusLembaga: {
            ...this.state.statusLembaga,
            form: true
          },
          judul: "Tambah Lembaga Kemasyarakatan",
          dtLembaga: frmLembaga,
        });
      };

      // UBAH DATA LEMBAGA
      ubahDataLembaga = (data) => {
        this.setState({
            statusLembaga:{
                ...this.state.statusLembaga,
                btnAksi: true,
            },
            judulLembaga: "Ubah Lembaga",
        })
        this.forceUpdate();
          this.setState({
              dtLembaga: data,
              statusLembaga:{
                  ...this.state.statusLembaga,
                  btnAksi: false,
              }
          })
          this.bukaFormLembaga();
      }
  
      // HAPUS DATA LEMBAGA
      konfirmHapusLembaga = (id) => {
        this.setState({
          alert: (
              <SweetAlert
                  showCancel
                  confirmBtnText="Hapus"
                  confirmBtnBsStyle="danger"
                  cancelBtnBsStyle="success"
                  type="danger"
                  title="Yakin ingin hapus data ?"
                  onCancel={this.hideAlert}
                  onConfirm={()=> this.hapusDataLembaga(id)}
              >
                  Proses ini tidak dapat dibatalkan!
              </SweetAlert>
          )
        });
      }

      hapusDataLembaga = (id) => {
        this.hideAlert();
        let psn = "Hapus";
        Delete('lembaga-kemasyarakatan/delete', id, (res) => {
            if (res === 200)
            {
                this.setState({ show: true, basicType:'success', basicTitle:'Data Lembaga', pesanAlert:'Berhasil '+psn+' Data' });
            }
            else
            {
                this.setState({ show: true, basicType:'danger', basicTitle:'Data Lembaga', pesanAlert:'Gagal '+psn+' Data' });
            }
            this.componentDidMount();
        })
      }
  
      // CARI DATA LEMBAGA
      cariDataLembaga = e => {
        if (e.key === 'Enter') {
          this.setState({ dataCariLembaga: e.target.value, });

          setTimeout(
            function() {
              this.fetch({ page: null, where: [] });
              // this.fetch(this.state.detailLembaga.uuid,{page: null});
            }.bind(this),
            500
          );
        }
      }
    // END DATA LEMBAGA

// ################################################################################################

  // DATA PERANGKAT LEMBAGA
    // FETCH DATA PERANGKAT LEMBAGA
    fetchPerangkat = (uuid, params = {}) => {
      this.setState({ loadingPerangkat: true })
      let linkPerangkat = "";
        if (params.page)
        {
            switch(params.page)
            {
                case '>>': linkPerangkat = "&page="+(Math.ceil(this.state.paginationPerangkat.total / this.state.paginationPerangkat.per_page));break;
                case '>': linkPerangkat = "&page="+(parseInt(this.state.paginationPerangkat.current_page) + 1);break;
                case '<': linkPerangkat = "&page="+(parseInt(this.state.paginationPerangkat.current_page) - 1);break;
                case '<<': linkPerangkat = "&page=1";break;
                default: linkPerangkat = "&page="+params.page;break;
            }
        }
        
      let cariPerangkat= '';
      if(this.state.dataCariPerangkat){
        cariPerangkat = '&q='+this.state.dataCariPerangkat
      }

      let id_lembaga = '';
      if(uuid){
        id_lembaga = uuid;
      }
      else{
        id_lembaga = this.state.detailLembaga
      }

      Get('perangkat-lembaga?uuid_lembaga='+id_lembaga+cariPerangkat+linkPerangkat, null, (dtkat) => {
        if (dtkat.results) {
          this.setState({ 
            loadingPerangkat: false,
            dataPerangkat: dtkat.results.data,
            paginationPerangkat:dtkat.results,
          });
          this.paginationPerangkat(dtkat.results);
        }
      });
    };

    // PAGINATION PERANGKAT LEMBAGA
    paginationPerangkat = (data) => {
      let awalPagePerangkat = "";
      let halPagePerangkat = [];
      let sebelumPagePerangkat = "";
      let setelahPagePerangkat = "";
      let akhirPagePerangkat = "";
      if (data.total > 0)
      {
          let start = 1;
          let end = 5;
          let n = 0;
          let p = 0;
          if (data.current_page <= 3)
          {   
              start = 1;
              end = 5;
              if (data.last_page > data.current_page)
              {
                  n = data.current_page + 1;
              }
          }
          else 
          {
              p = data.current_page - 1;
              n = data.current_page + 1;
              start = data.current_page - 2;
              end = data.current_page + 2;
          }
          if (end >= data.last_page - 2)
          {
              p = data.current_page - 1;
              if (start >= 5)
              {
                  start = data.last_page - 4;
              }
              end = data.last_page;
          }

          for (let i=start;i<=end;i++) 
          {
              let warna = "primary-custom";
              if (i === data.current_page)
              {
                  warna = "danger"
              }
              halPagePerangkat.push(<a href={() => false} onClick={()=>this.fetchPerangkat(this.state.detailLembaga.uuid, {page:i})} className={"btn btn-"+warna+" btn-square btn-sm pr-3 pl-3 pt-2 pb-2"}>{i}</a>)
          }
          if (p > 0)
          {
              sebelumPagePerangkat = (<a href={() => false} onClick={()=>this.fetchPerangkat(this.state.detailLembaga.uuid, {page:p})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<"}</a>)
          }
          if (n > 0)
          {
              setelahPagePerangkat = (<a href={() => false} onClick={()=>this.fetchPerangkat(this.state.detailLembaga.uuid, {page:n})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">"}</a>)
          }
          awalPagePerangkat = (<a href={() => false} onClick={()=>this.fetchPerangkat(this.state.detailLembaga.uuid, {page:1})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<<"}</a>)
          akhirPagePerangkat = (<a href={() => false} onClick={()=>this.fetchPerangkat(this.state.detailLembaga.uuid, {page:data.last_page})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">>"}</a>)
      }
      this.setState({awalPagePerangkat,sebelumPagePerangkat,halPagePerangkat,setelahPagePerangkat,akhirPagePerangkat});
    }

    // DETAIL DATA PERANGKAT LEMBAGA
    detailDataPerangkat = (data) => {
      this.setState({
          statusDetailPerangkat:{
              ...this.state.statusDetailPerangkat,
              btnAksi: true,
          },
          // judulLembaga: "Ubah Lembaga",
      })
      this.forceUpdate();
        this.setState({
            detailPerangkat: data,
            statusDetailPerangkat:{
                ...this.state.statusDetailPerangkat,
                btnAksi: false,
                form: true,
            }
        })
        // this.bukaFormLembaga();
    }

    // TOMBOL AKSI PERANGKAT LEMBAGA
    tombolAksiPerangkat = (cell, row) => {
      return (
        <div>
          <Button  size="xs" color="btn btn-secondary" className="btn-icon" onClick={() => this.detailDataPerangkat(row)} disabled={this.state.statusPerangkat.btnAksi}><i className="fa fa-eye"></i></Button> {' '}&nbsp;&nbsp;
          <Button
            size="xs"
            color="success"
            className="btn-icon"
            onClick={() => this.ubahdataPerangkat(row)}
            disabled={this.state.statusPerangkat.btnAksi}
          >
            <i className="fa fa-pencil" />
          </Button>{' '}
          &nbsp;&nbsp;
          <Button
            size="xs"
            color="danger"
            className="btn-icon"
            onClick={() => this.konfirmHapusPerangkat(row.uuid)}
            disabled={this.state.statusPerangkat.btnAksi}
          >
            <i className="fa fa-trash" />
          </Button>
        </div>
      );
    };
  
    // TAMBAH DATA PERANGKAT LEMBAGA
    tambahPerangkat = e => {     
      this.setState({
        statusPerangkat: {
          ...this.state.statusPerangkat,
          form: true
        },
        dtPerangkat: {
          uuid: '',
          uuid_lembaga: this.state.detailLembaga.uuid,
          uuid_jabatan_lembaga: null,
          uuid_bidang_lembaga: null,
          nama: '',
          status: '1',
          foto: '',
        },
        uuidLembaga: this.state.detailLembaga.uuid,
        jabatanStat: null,
        bidangStat: null,
      });

    };

    // UBAH DATA PERANGKAT LEMBAGA
    ubahdataPerangkat = (data) => {
      this.setState({
        statusPerangkat: {
          ...this.state.statusPerangkat,
          form: true
        },
        dtPerangkat: data,
        jabatanStat: { value: data.data_jabatan_lembaga? data.data_jabatan_lembaga.uuid:'' , label: data.data_jabatan_lembaga?data.data_jabatan_lembaga.nama:''},
        bidangStat: { value: data.data_bidang_lembaga? data.data_bidang_lembaga.uuid:'' , label: data.data_bidang_lembaga?data.data_bidang_lembaga.nama:''},
      });
    };
    
    // HAPUS DATA PERANGKAT LEMBAGA
    konfirmHapusPerangkat = (id) => {
      this.setState({
        alert: (
          <SweetAlert
            showCancel
            confirmBtnText="Hapus"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="success"
            type="danger"
            title="Yakin ingin hapus data ?"
            onCancel={this.hideAlert}
            onConfirm={() => this.hapusDataPerangkat(id)}
          >
            Proses ini tidak dapat dibatalkan!
          </SweetAlert>
        )
      });
    };

    hapusDataPerangkat = (id) => {
      this.hideAlert();
      let psn = 'Hapus';
      Delete('perangkat-lembaga/delete', id, (res) => {
        if (res === 200) {
          this.setState({
            show: true,
            basicType: 'success',
            basicTitle: 'Data Perangkat Lembaga',
            pesanAlert: 'Berhasil ' + psn + ' Data'
          });
          this.componentDidMount();
          this.fetchPerangkat(this.state.detailLembaga.uuid,{page: null});
        } else {
          this.setState({
            show: true,
            basicType: 'danger',
            basicTitle: 'Data Perangkat Lembaga',
            pesanAlert: 'Gagal ' + psn + ' Data'
          });
        }
      });
    };

    // CARI DATA PERANGKAT LEMBAGA
    cariDataPerangkat = e => {
      if (e.key === 'Enter') {
         this.setState({ dataCariPerangkat: e.target.value, });

         setTimeout(
           function() {
            this.fetchPerangkat(this.state.uuidLembaga, { page: null, where: [] });
           }.bind(this),
           500
         );
      }
    }

  // END DATA PERANGKAT LEMBAGA

// ################################################################################################
  
  // DATA JABATAN PERANGKAT LEMBAGA
    // FETCH DATA JABATAN PERANGKAT LEMBAGA
    fetchJabatanPerangkat = (uuid, params = {}) => {
      this.setState({ loadingJabatanPerangkat: true })

        let linkJabatanPerangkat = "";
        if (params.page)
        {
          switch(params.page)
          {
              case '>>': linkJabatanPerangkat = "&page="+(Math.ceil(this.state.paginationJabatanPerangkat.total / this.state.paginationJabatanPerangkat.per_page));break;
              case '>': linkJabatanPerangkat = "&page="+(parseInt(this.state.paginationJabatanPerangkat.current_page) + 1);break;
              case '<': linkJabatanPerangkat = "&page="+(parseInt(this.state.paginationJabatanPerangkat.current_page) - 1);break;
              case '<<': linkJabatanPerangkat = "&page=1";break;
              default: linkJabatanPerangkat = "&page="+params.page;break;
          }
      }

      let cariJabatanPerangkat= '';
      if(this.state.dataCariJabatanPerangkat){
        cariJabatanPerangkat = '&q='+this.state.dataCariJabatanPerangkat
      }

      let id_lembaga = '';
      if(uuid){
        id_lembaga = uuid;
      }
      else{
        id_lembaga = this.state.detailLembaga
      }

      Get('jenis-jabatan-lembaga?uuid_lembaga='+id_lembaga+cariJabatanPerangkat+linkJabatanPerangkat, null, (dtkat) => {

        if (dtkat.results) {
          this.setState({
            dataJabatanPerangkat: dtkat.results.data,
            paginationJabatanPerangkat:dtkat.results,
            loadingJabatanPerangkat: false
          })
          this.paginationJabatanPerangkat(dtkat.results);
        }
      });
    };

    // PAGINATION DATA JABATAN PERANGKAT LEMBAGA
    paginationJabatanPerangkat = (data) => {
      let awalJabatanPerangkat = "";
      let halJabatanPerangkat = [];
      let sebelumJabatanPerangkat = "";
      let setelahJabatanPerangkat = "";
      let akhirJabatanPerangkat = "";
      if (data.total > 0)
      {
          let start = 1;
          let end = 5;
          let n = 0;
          let p = 0;
          if (data.current_page <= 3)
          {   
              start = 1;
              end = 5;
              if (data.last_page > data.current_page)
              {
                  n = data.current_page + 1;
              }
          }
          else 
          {
              p = data.current_page - 1;
              n = data.current_page + 1;
              start = data.current_page - 2;
              end = data.current_page + 2;
          }
          if (end >= data.last_page - 2)
          {
              p = data.current_page - 1;
              if (start >= 5)
              {
                  start = data.last_page - 4;
              }
              end = data.last_page;
          }
  
          for (let i=start;i<=end;i++) 
          {
              let warna = "primary-custom";
              if (i === data.current_page)
              {
                  warna = "danger"
              }
              halJabatanPerangkat.push(<a href={() => false} onClick={()=>this.fetchJabatanPerangkat({page:i})} className={"btn btn-"+warna+" btn-square btn-sm pr-3 pl-3 pt-2 pb-2"}>{i}</a>)
          }
          if (p > 0)
          {
              sebelumJabatanPerangkat = (<a href={() => false} onClick={()=>this.fetchJabatanPerangkat({page:p})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<"}</a>)
          }
          if (n > 0)
          {
              setelahJabatanPerangkat = (<a href={() => false} onClick={()=>this.fetchJabatanPerangkat({page:n})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">"}</a>)
          }
          awalJabatanPerangkat = (<a href={() => false} onClick={()=>this.fetchJabatanPerangkat({page:1})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<<"}</a>)
          akhirJabatanPerangkat = (<a href={() => false} onClick={()=>this.fetchJabatanPerangkat({page:data.last_page})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">>"}</a>)
      }
      this.setState({awalJabatanPerangkat,sebelumJabatanPerangkat,halJabatanPerangkat,setelahJabatanPerangkat,akhirJabatanPerangkat});
    }

    // TOMBOL AKSI JABATAN PERANGKAT LEMBAGA
    tombolAksiJabatanPerangkat = (cell, row) => {
      return (
        <>
            <Button  size="xs" color="success" className="btn-icon" onClick={() => this.ubahDataJabatanPerangkat(row)} disabled={this.state.statusJabatanPerangkat.btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;&nbsp;
            <Button  size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmJabatanPerangkat(row.uuid)} disabled={this.state.statusJabatanPerangkat.btnAksi}><i className="fa fa-trash"></i></Button>  
        </>
      )
    }
    
    // TAMBAH DATA JABATAN PERANGKAT LEMBAGA
    tambahJabatanPerangkat = e => {
      this.setState({
        statusJabatanPerangkat: {
          ...this.state.statusJabatanPerangkat,
          form: true
        },
        dtJabatanPerangkat: {
          uuid: '',
          uuid_lembaga: this.state.detailLembaga.uuid,
          nama: '',
          urutan: '',
        },
        uuidLembaga: this.state.detailLembaga.uuid,
      });
    };

    // UBAH DATA JABATAN PERANGKAT LEMBAGA
    ubahDataJabatanPerangkat = (data) => {
      this.setState({
        statusJabatanPerangkat: {
          ...this.state.statusJabatanPerangkat,
          form: true
        },
        dtJabatanPerangkat: data,
      });
    };
    
    // HAPUS DATA JABATAN PERANGKAT LEMBAGA
    konfirmJabatanPerangkat = (id) => {
      this.setState({
          alert: (
              <SweetAlert
                  showCancel
                  confirmBtnText="Hapus"
                  confirmBtnBsStyle="danger"
                  cancelBtnBsStyle="success"
                  type="danger"
                  title="Yakin ingin hapus data ?"
                  onCancel={this.hideAlert}
                  onConfirm={()=> this.hapusDataJabatanPerangkat(id)}
              >
                  Proses ini tidak dapat dibatalkan!
              </SweetAlert>
          )
      });
    }

    hapusDataJabatanPerangkat = (id) => {
      this.hideAlert();
      let psn = 'Hapus';
      Delete('jenis-jabatan-lembaga/delete', id, (res) => {
        if (res === 200) {
          this.setState({
            show: true,
            basicType: 'success',
            basicTitle: 'Data Jabatan Perangkat Lembaga',
            pesanAlert: 'Berhasil ' + psn + ' Data'
          });
          this.componentDidMount();
          this.fetchJabatanPerangkat(this.state.detailLembaga.uuid,{page: null});
        } else {
          this.setState({
            show: true,
            basicType: 'danger',
            basicTitle: 'Data Jabatan Perangkat Lembaga',
            pesanAlert: 'Gagal ' + psn + ' Data'
          });
        }
      });
    };

    // CARI DATA JABATAN PERANGKAT LEMBAGA
    cariDataJabatanPerangkat = e => {
      if (e.key === 'Enter') {
         this.setState({ dataCariJabatanPerangkat: e.target.value, });

         setTimeout(
           function() {
            this.fetchJabatanPerangkat(this.state.uuidLembaga, { page: null, where: [] });
           }.bind(this),
           500
         );
      }
    }
  
  // END DATA JABATAN PERANGKAT LEMBAGA

// ################################################################################################

  // DATA BIDANG LEMBAGA
    // FETCH DATA BIDANG LEMBAGA
    fetchBidang = (uuid, params = {}) => {
      this.setState({ loadingBidang: true })
      let linkBidang = "";
        if (params.page)
        {
            switch(params.page)
            {
                case '>>': linkBidang = "&page="+(Math.ceil(this.state.paginationBidang.total / this.state.paginationBidang.per_page));break;
                case '>': linkBidang = "&page="+(parseInt(this.state.paginationBidang.current_page) + 1);break;
                case '<': linkBidang = "&page="+(parseInt(this.state.paginationBidang.current_page) - 1);break;
                case '<<': linkBidang = "&page=1";break;
                default: linkBidang = "&page="+params.page;break;
            }
        }
        
      let cariBidang= '';
      if(this.state.dataCariBidang){
        cariBidang = '&q='+this.state.dataCariBidang
      }

      let id_lembaga = '';
      if(uuid){
        id_lembaga = uuid;
      }
      else{
        id_lembaga = this.state.detailLembaga
      }

      Get('bidang-lembaga?uuid_lembaga='+id_lembaga+cariBidang+linkBidang, null, (dtkat) => {
        if (dtkat.results) {
          this.setState({ 
            loadingBidang: false,
            dataBidang: dtkat.results.data,
            paginationBidang:dtkat.results,
          });
          this.paginationBidang(dtkat.results);
        }
      });
    };

    // PAGINATON BIDANG LEMBAGA
    paginationBidang = (data) => {
      let awalPageBidang = "";
      let halPageBidang = [];
      let sebelumPageBidang = "";
      let setelahPageBidang = "";
      let akhirPageBidang = "";
      if (data.total > 0)
      {
          let start = 1;
          let end = 5;
          let n = 0;
          let p = 0;
          if (data.current_page <= 3)
          {   
              start = 1;
              end = 5;
              if (data.last_page > data.current_page)
              {
                  n = data.current_page + 1;
              }
          }
          else 
          {
              p = data.current_page - 1;
              n = data.current_page + 1;
              start = data.current_page - 2;
              end = data.current_page + 2;
          }
          if (end >= data.last_page - 2)
          {
              p = data.current_page - 1;
              if (start >= 5)
              {
                  start = data.last_page - 4;
              }
              end = data.last_page;
          }

          for (let i=start;i<=end;i++) 
          {
              let warna = "primary-custom";
              if (i === data.current_page)
              {
                  warna = "danger"
              }
              halPageBidang.push(<a href={() => false} onClick={()=>this.fetchBidang(this.state.detailLembaga.uuid, {page:i})} className={"btn btn-"+warna+" btn-square btn-sm pr-3 pl-3 pt-2 pb-2"}>{i}</a>)
          }
          if (p > 0)
          {
              sebelumPageBidang = (<a href={() => false} onClick={()=>this.fetchBidang(this.state.detailLembaga.uuid, {page:p})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<"}</a>)
          }
          if (n > 0)
          {
              setelahPageBidang = (<a href={() => false} onClick={()=>this.fetchBidang(this.state.detailLembaga.uuid, {page:n})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">"}</a>)
          }
          awalPageBidang = (<a href={() => false} onClick={()=>this.fetchBidang(this.state.detailLembaga.uuid, {page:1})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<<"}</a>)
          akhirPageBidang = (<a href={() => false} onClick={()=>this.fetchBidang(this.state.detailLembaga.uuid, {page:data.last_page})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">>"}</a>)
      }
      this.setState({awalPageBidang,sebelumPageBidang,halPageBidang,setelahPageBidang,akhirPageBidang});
    }
    
    // TOMBOL AKSI BIDANG LEMBAGA
    tombolAksiBidang = (cell, row) => {
      return (
        <div>
          {/* <Button  size="xs" color="btn btn-secondary" className="btn-icon" onClick={() => this.detailDataPerangkat(row)} disabled={this.state.statusBidang.btnAksi}><i className="fa fa-eye"></i></Button> {' '}&nbsp;&nbsp; */}
          <Button
            size="xs"
            color="success"
            className="btn-icon"
            onClick={() => this.ubahdataBidang(row)}
            disabled={this.state.statusBidang.btnAksi}
          >
            <i className="fa fa-pencil" />
          </Button>{' '}
          &nbsp;&nbsp;
          <Button
            size="xs"
            color="danger"
            className="btn-icon"
            onClick={() => this.konfirmHapusBidang(row.uuid)}
            disabled={this.state.statusBidang.btnAksi}
          >
            <i className="fa fa-trash" />
          </Button>
        </div>
      );
    };

    // TAMBAH DATA BIDANG LEMBAGA
    
    tambahBidang = e => {
      this.setState({
        statusBidang: {
          ...this.state.statusBidang,
          form: true
        },
        dtBidang: {
          uuid: '',
          uuid_lembaga: this.state.detailLembaga.uuid,
          nama: '',
        },
        uuidLembaga: this.state.detailLembaga.uuid,
      });
    };

    // UBAH DATA BIDANG LEMBAGA
    ubahdataBidang = (data) => {

      this.setState({
        statusBidang: {
          ...this.state.statusBidang,
          form: true
        },
        dtBidang: data,
      });
    };

    // HAPUS DATA BIDANG LEMBAGA
    konfirmHapusBidang = (id) => {
      this.setState({
        alert: (
          <SweetAlert
            showCancel
            confirmBtnText="Hapus"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="success"
            type="danger"
            title="Yakin ingin hapus data ?"
            onCancel={this.hideAlert}
            onConfirm={() => this.hapusDataBidang(id)}
          >
            Proses ini tidak dapat dibatalkan!
          </SweetAlert>
        )
      });
    };

    hapusDataBidang = (id) => {
      this.hideAlert();
      let psn = 'Hapus';
      Delete('bidang-lembaga/delete', id, (res) => {
        if (res === 200) {
          this.setState({
            show: true,
            basicType: 'success',
            basicTitle: 'Data Bidang Lembaga',
            pesanAlert: 'Berhasil ' + psn + ' Data'
          });
          this.componentDidMount();
          this.fetchBidang(this.state.detailLembaga.uuid,{page: null});
        } else {
          this.setState({
            show: true,
            basicType: 'danger',
            basicTitle: 'Data Bidang Lembaga',
            pesanAlert: 'Gagal ' + psn + ' Data'
          });
        }
      });
    };

    // CARI DATA BIDANG
    cariDataBidang = e => {
      if (e.key === 'Enter') {
         this.setState({ dataCariBidang: e.target.value, });

         setTimeout(
           function() {
            this.fetchBidang(this.state.uuidLembaga, { page: null, where: [] });
           }.bind(this),
           500
         );
      }
    }

  // END DATA BIDANG LEMBAGA
  
// ################################################################################################

  // TAMBAH PROFIL
  tambahProfil  = (e, jenis) => {
    this.setState({
      statusProfil: {
        ...this.state.statusProfil,
        form: true
      },
      detailLembaga: this.state.detailLembaga,
      judulProfil: jenis +" Profil "+this.state.detailLembaga.nama_lembaga,
    });
  };

  // REFRESH PROFIL
  refreshProfil = (id) => {
    this.setState({
      loadingProfil: true,
    })
    Get("lembaga-kemasyarakatan/find/"+id, null, data => {
      this.setState({
        loadingProfil: false,
      })

      if(data.results){
        this.setState({
          detailLembaga: data.results
        })
      }
    });
  }

  // GET DATA LIST JABATAN
  getDataJabatan = (id) => {
    Get("jenis-jabatan-lembaga?uuid_lembaga="+id, null, data => {
      let listJabatan = [];
      if(data.results.data){
        data.results.data.forEach(dt => {
          listJabatan.push({ value: dt.uuid, label: dt.nama });
        });
      }
      this.setState({ listJabatan });
    });
  }

  // GET DATA LIST BIDANG
  getDataBidang = (id) => {
    Get("bidang-lembaga?uuid_lembaga="+id, null, data => {
      let listBidang = [];
      if(data.results.data){
        data.results.data.forEach(dt => {
          listBidang.push({ value: dt.uuid, label: dt.nama });
        });
      }
      this.setState({ listBidang });
    });
  }

	componentDidMount() {
		this.fetch({ page: null, where: [] });

    // GET DATA MENU VERTICAL
    Get('lembaga-kemasyarakatan', null, (dtkat) => {
      if(dtkat.results.data.length === 0){
        this.setState({
          listDataLembaga: dtkat.results.data,
        })
      }
      else{
        if (dtkat.results) {
          this.setState({ 
            listDataLembaga: dtkat.results.data,
          });
        }
      }
		});
	}
  
	render() {
    var dataLembaga = this.state.dataLembaga;
    var dataPerangkat = this.state.dataPerangkat;
    var dataJabatanPerangkat = this.state.dataJabatanPerangkat;
    var dataBidang = this.state.dataBidang;
 
    const columnsLembaga = [
      {
          dataField: "no",
          text: "No",
          headerAlign: 'center',
          align: 'center',
          style: {
            width: '100px'
          },
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationLembaga.current_page;
              let total_records_per_page = this.state.paginationLembaga.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
          dataField: 'nama_lembaga',
          text: 'Nama Lembaga',
          headerAlign: 'center',
          align: 'center',
          sort: true
      },
      {
          dataField: 'tahun_berdiri',
          text: 'Tanggal Berdiri',
          headerAlign: 'center',
          align: 'center',
          sort: true
      },
     
      {
          dataField: 'status',
          text: 'Status',
          headerAlign: 'center',
          align: 'center',
          // isDummyField: true,
          // formatter: (cell, data) => data.status==='Aktif'?"Ya":"Tidak Aktif",
          sort: true
      },
      {
          dataField: 'aksi',
          text: 'Aksi',
          headerAlign: 'center',
          align: 'center',
          style: {
            width: '150px'
          },
          formatter: this.tombolAksiLembaga,
      },
    ];
    
    const columnsPerangkat = [
      {
          dataField: "no",
          text: "No",
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationPerangkat.current_page;
              let total_records_per_page = this.state.paginationPerangkat.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
          dataField: 'nama',
          text: 'Nama Perangkat',
          headerAlign: 'center',
          align: 'center',
          sort: true
      },
      {
          dataField: 'uuid_jabatan_lembaga',
          text: 'Jabatan',
          isDummyField: true,
          headerAlign: 'center',
          align: 'center',
          formatter: (cell, data) => data.data_jabatan_lembaga?data.data_jabatan_lembaga.nama:"",
          sort: true
      },
      {
          dataField: 'uuid_bidang_lembaga',
          text: 'Bidang',
          isDummyField: true,
          headerAlign: 'center',
          align: 'center',
          formatter: (cell, data) => data.data_bidang_lembaga?data.data_bidang_lembaga.nama:"",
          sort: true
      },

      {
          dataField: 'status',
          text: 'Status',
          headerAlign: 'center',
          align: 'center',
          sort: true,
          formatter: (cell, data) => data.status===1?"Aktif":"Tidak Aktif",
      },
      {
          dataField: 'aksi',
          text: 'Aksi',
          headerAlign: 'center',
          align: 'center',
          formatter: this.tombolAksiPerangkat,
      },
    ];
    
    const columnsJabatanPerangkat = [
      {
          dataField: "no",
          text: "No",
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationJabatanPerangkat.current_page;
              let total_records_per_page = this.state.paginationJabatanPerangkat.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
          dataField: 'nama',
          text: 'Nama Jabatan',
          headerAlign: 'center',
          align: 'center',
          sort: true
      },
      {
          dataField: 'urutan',
          text: 'Urutan',
          headerAlign: 'center',
          align: 'center',
          sort: true
      },

      {
          dataField: 'aksi',
          text: 'Aksi',
          headerAlign: 'center',
          align: 'center',
          formatter: this.tombolAksiJabatanPerangkat,
      },
    ];

    const columnsBidang = [
      {
          dataField: "no",
          text: "No",
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationBidang.current_page;
              let total_records_per_page = this.state.paginationBidang.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
          dataField: 'nama',
          text: 'Nama Bidang',
          headerAlign: 'center',
          align: 'center',
          sort: true
      },
      {
          dataField: 'aksi',
          text: 'Aksi',
          headerAlign: 'center',
          align: 'center',
          formatter: this.tombolAksiBidang,
      },
    ];

    var htmlToReactParser = new HtmlToReactParser();

		return (
			<div>
				{/* <Breadcrumb title="Data Profile" parent="Admin"/> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}
				
          <div className="container-fluid">
              <div className="row">
                  <div className="col-sm-12">
                      <div className="card mb-0">
                          <div className="card-header">
                            <div className="row">
                              <div className="col-lg-3">
                                <Nav className={'nav flex-column nav-pills'}>
                                  <NavItem>
                                    <NavLink className={classnames({ active: this.state.active_tab_vertical === 999998 })} onClick={() => { this.toggle_vertical(999998, 'data master'); }}>
                                        <b>Data Lembaga Masyarakat <i className='fa fa-star'></i></b>
                                    </NavLink>
                                  </NavItem>
                                  {this.state.loading ? (
                                    <div className="row">
                                      <div className="col-sm-12" align="center">
                                        <img
                                          alt="loading"
                                          src={require("../../../assets/images/tes-loading.gif")}
                                          style={{
                                            borderRadius: "10px",
                                            width: '100px'
                                          }} />
                                      </div>
                                    </div>
                                  ) : 
                                    this.state.listDataLembaga.length !==  0 ? (
                                      this.state.listDataLembaga.map((dt, index) => {
                                        return (
                                          <>
                                            <NavItem>
                                              <NavLink className={classnames({ active: this.state.active_tab_vertical === index + 1 })}
                                                  onClick={() => { this.toggle_vertical(index + 1, dt); }}>
                                                {dt.nama_lembaga}
                                              </NavLink>
                                            </NavItem>
                                          </>
                                        );
                                      })
                                    ) : (
                                      <>
                                        <Label
                                          className="col-sm-12 col-form-label text-center"
                                          htmlFor="inputEmail3"
                                        >
                                          {/* Data Lembaga Belum Ada */}
                                        </Label>
                                      </>
                                    )
                                  }
                                </Nav>
                              </div>
                              <div className="col-lg-9">
                                <TabContent activeTab={this.state.active_tab_vertical}>
                                {this.state.listDataLembaga.length !==  0 ? (
                                    this.state.listDataLembaga.map((dt, index) => {
                                      return (
                                        <>
                                          <TabPane tabId={index + 1}>
                                            <Row>
                                              {/* Horizontal Tab */}
                                              <Nav tabs className="tabs-color">
                                                <NavItem style={{ cursor: 'pointer' }}>
                                                  <NavLink
                                                    className={classnames({
                                                      active: this.state.active_tab_icon === '1'
                                                    })}
                                                    onClick={() => {
                                                      this.toggle_icon('1');
                                                    }}
                                                  >
                                                    <i className="icofont icofont-ui-home" />
                                                    Profil Lembaga
                                                  </NavLink>
                                                </NavItem>
                                                <NavItem style={{ cursor: 'pointer' }}>
                                                  <NavLink
                                                    className={classnames({
                                                      active: this.state.active_tab_icon === '2'
                                                    })}
                                                    onClick={() => {
                                                      this.toggle_icon('2');
                                                    }}
                                                  >
                                                    <i className="icofont icofont-man-in-glasses" />
                                                    Perangkat Lembaga
                                                  </NavLink>
                                                </NavItem>
                                                <NavItem style={{ cursor: 'pointer' }}>
                                                  <NavLink
                                                    className={classnames({
                                                      active: this.state.active_tab_icon === '3'
                                                    })}
                                                    onClick={() => {
                                                      this.toggle_icon('3');
                                                    }}
                                                  >
                                                    <i className="icofont icofont-man-in-glasses" />
                                                    Jabatan Perangkat Lembaga
                                                  </NavLink>
                                                </NavItem>
                                                <NavItem style={{ cursor: 'pointer' }}>
                                                  <NavLink
                                                    className={classnames({
                                                      active: this.state.active_tab_icon === '4'
                                                    })}
                                                    onClick={() => {
                                                      this.toggle_icon('4');
                                                    }}
                                                  >
                                                    <i className="icofont icofont-man-in-glasses" />
                                                    Bidang Lembaga
                                                  </NavLink>
                                                </NavItem>
                                              </Nav>
                                              <TabContent activeTab={this.state.active_tab_icon} style={{width:'100%'}}>
                                                <TabPane tabId="1">
                                                  <Row>
                                                    <Col sm="12">
                                                      <div className="card mb-0">
                                                          <div className="card-header">
                                                            <div className="row datatable-react">
                                                              <div className="col-sm-6 text-left">
                                                                &nbsp;
                                                              </div>
                                                              <div className="col-sm-6 text-right">
                                                              {this.state.detailLembaga.profil?
                                                              <>
                                                                <Button
                                                                  size="sm"
                                                                  color="success"
                                                                  onClick={(e) => {
                                                                    this.tambahProfil(e,'Ubah');
                                                                  }}
                                                                >
                                                                  Ubah Data
                                                                </Button> 
                                                              </>
                                                              :
                                                              <>
                                                                <Button
                                                                  size="sm"
                                                                  color="success"
                                                                  onClick={(e) => {
                                                                    this.tambahProfil(e,'Tambah');
                                                                  }}
                                                                >
                                                                  Tambah Data
                                                                </Button> 
                                                              </>
                                                              }          
                                                              </div>
                                                              <div className="datatable-react col-sm-12 text-center">
                                                                <h5>Profil {this.state.detailLembaga.nama_lembaga}</h5>
                                                              </div>
                                                              <div className="col-sm-12">
                                                                &nbsp;
                                                              </div>
                                                            </div>
                                                            <div className="datatable-react col-12">
                                                              &nbsp;
                                                            </div>
                                                            <div className="datatable-react">
                                                            {this.state.loadingProfil ? 
                                                              <>
                                                                <div className="row">
                                                                  <div className="col-sm-12" align="center">
                                                                    <img
                                                                      alt="loading"
                                                                      src={require("../../../assets/images/tes-loading.gif")}
                                                                      style={{
                                                                        borderRadius: "10px",
                                                                        width: '100px'
                                                                      }} />
                                                                  </div>
                                                                </div>
                                                              </>
                                                              : this.state.detailLembaga?
                                                              this.state.detailLembaga.profil ? 
                                                                <>
                                                                  {htmlToReactParser.parse(this.state.detailLembaga.profil)}
                                                                </>
                                                               : 
                                                                <>
                                                                  <h6 className="text-center mb-2 mt-2">Data Profil Belum Ada</h6>
                                                                </>
                                                              :''}
                                                            </div>
                                                          </div>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </TabPane>
                                                <TabPane tabId="2">
                                                  <Row>
                                                    <Col sm="12">
                                                      <div className="card mb-0" style={{minWidth:'100%'}}>
                                                          <div className="card-header">
                                                            <div className="row datatable-react">
                                                              <div className="datatable-react col-sm-12">
                                                                <h5>Perangkat {this.state.detailLembaga.nama_lembaga}</h5>
                                                              </div>
                                                              <div className="col-sm-12">&nbsp;</div>
                                                              <div className="col-sm-6 text-left">
                                                                <input
                                                                  type="search"
                                                                  className="form-control"
                                                                  id="cariTable"
                                                                  placeholder="Cari Data..."
                                                                  defaultValue={this.state.dataCariPerangkat}
                                                                  onKeyPress={this.cariDataPerangkat}
                                                                />   
                                                              </div>
                                                              <div className="col-sm-6 text-right">
                                                                <Button
                                                                  size="sm"
                                                                  color="success"
                                                                  onClick={() => {
                                                                    this.tambahPerangkat();
                                                                    this.setState({
                                                                      jabatanStat: null,
                                                                      detailLembaga: this.state.detailLembaga
                                                                    })
                                                                  }}
                                                                >
                                                                  Tambah Data
                                                                </Button>       
                                                              </div>
                                                            </div>
                                                            <div className="datatable-react col-12">
                                                              &nbsp;
                                                            </div>
                                                            <div className="datatable-react">
                                                              {this.state.loadingPerangkat ? (
                                                                <div className="row">
                                                                  <div className="col-sm-12" align="center">
                                                                    <img
                                                                      alt="loading"
                                                                      src={require("../../../assets/images/tes-loading.gif")}
                                                                      style={{
                                                                        borderRadius: "10px",
                                                                        width: '100px'
                                                                      }} />
                                                                  </div>
                                                                </div>
                                                              ) : dataPerangkat.length > 0 ? (
                                                                <>
                                                                <BootstrapTable
                                                                    keyField="id"
                                                                    data={ dataPerangkat }
                                                                    columns={ columnsPerangkat }
                                                                    />
                                                                <div className="pull-right text-white">
                                                                    {this.state.awalPagePerangkat}{this.state.sebelumPagePerangkat}{this.state.halPagePerangkat.map(dt=> { return dt})}{this.state.setelahPagePerangkat}{this.state.akhirPagePerangkat}
                                                                </div>
                                                                </>
                                                              ) : (
                                                                <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                              )}
                                                            </div>
                                                          </div>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </TabPane>
                                                <TabPane tabId="3">
                                                  <Row>
                                                    <Col sm="12">
                                                      <div className="card mb-0" style={{minWidth:'100%'}}>
                                                          <div className="card-header">
                                                            <div className="row datatable-react">
                                                              <div className="datatable-react col-sm-12">
                                                                <h5>Jabatan Perangkat {this.state.detailLembaga.nama_lembaga}</h5>
                                                              </div>
                                                              <div className="col-sm-12">&nbsp;</div>
                                                              <div className="col-sm-6 text-left">
                                                                <input
                                                                  type="search"
                                                                  className="form-control"
                                                                  id="cariTable"
                                                                  placeholder="Cari Data..."
                                                                  defaultValue={this.state.dataCariJabatanPerangkat}
                                                                  onKeyPress={this.cariDataJabatanPerangkat}
                                                                />   
                                                              </div>
                                                              <div className="col-sm-6 text-right">
                                                                <Button
                                                                  size="sm"
                                                                  color="success"
                                                                  onClick={() => {
                                                                    this.tambahJabatanPerangkat();
                                                                    this.setState({
                                                                      detailLembaga: this.state.detailLembaga
                                                                    })
                                                                  }}
                                                                >
                                                                  Tambah Data
                                                                </Button>       
                                                              </div>
                                                            </div>
                                                            <div className="datatable-react col-12">
                                                              &nbsp;
                                                            </div>
                                                            <div className="datatable-react">
                                                              {this.state.loadingJabatanPerangkat ? (
                                                                <div className="row">
                                                                  <div className="col-sm-12" align="center">
                                                                    <img
                                                                      alt="loading"
                                                                      src={require("../../../assets/images/tes-loading.gif")}
                                                                      style={{
                                                                        borderRadius: "10px",
                                                                        width: '100px'
                                                                      }} />
                                                                  </div>
                                                                </div>
                                                              ) : dataJabatanPerangkat.length > 0 ? (
                                                                <>
                                                                <BootstrapTable
                                                                    keyField="id"
                                                                    data={ dataJabatanPerangkat }
                                                                    columns={ columnsJabatanPerangkat }
                                                                    />
                                                                <div className="pull-right text-white">
                                                                    {this.state.awalJabatanPerangkat}{this.state.sebelumJabatanPerangkat}{this.state.halJabatanPerangkat.map(dt=> { return dt})}{this.state.setelahJabatanPerangkat}{this.state.akhirJabatanPerangkat}
                                                                </div>
                                                                </>
                                                              ) : (
                                                                <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                              )}
                                                            </div>
                                                          </div>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </TabPane>
                                                <TabPane tabId="4">
                                                  <Row>
                                                    <Col sm="12">
                                                      <div className="card mb-0" style={{minWidth:'100%'}}>
                                                          <div className="card-header">
                                                            <div className="row datatable-react">
                                                              <div className="datatable-react col-sm-12">
                                                                <h5>Bidang Lembaga {this.state.detailLembaga.nama_lembaga}</h5>
                                                              </div>
                                                              <div className="col-sm-12">&nbsp;</div>
                                                              <div className="col-sm-6 text-left">
                                                                <input
                                                                  type="search"
                                                                  className="form-control"
                                                                  id="cariTable"
                                                                  placeholder="Cari Data..."
                                                                  defaultValue={this.state.dataCariPerangkat}
                                                                  onKeyPress={this.cariDataBidang}
                                                                />   
                                                              </div>
                                                              <div className="col-sm-6 text-right">
                                                                <Button
                                                                  size="sm"
                                                                  color="success"
                                                                  onClick={() => {
                                                                    this.tambahBidang();
                                                                    this.setState({
                                                                      jabatanStat: null,
                                                                      detailLembaga: this.state.detailLembaga
                                                                    })
                                                                  }}
                                                                >
                                                                  Tambah Data
                                                                </Button>       
                                                              </div>
                                                            </div>
                                                            <div className="datatable-react col-12">
                                                              &nbsp;
                                                            </div>
                                                            <div className="datatable-react">
                                                              {this.state.loadingBidang ? (
                                                                <div className="row">
                                                                  <div className="col-sm-12" align="center">
                                                                    <img
                                                                      alt="loading"
                                                                      src={require("../../../assets/images/tes-loading.gif")}
                                                                      style={{
                                                                        borderRadius: "10px",
                                                                        width: '100px'
                                                                      }} />
                                                                  </div>
                                                                </div>
                                                              ) : dataBidang.length > 0 ? (
                                                                <>
                                                                <BootstrapTable
                                                                    keyField="id"
                                                                    data={ dataBidang }
                                                                    columns={ columnsBidang }
                                                                    />
                                                                <div className="pull-right text-white">
                                                                    {this.state.awalPageBidang}{this.state.sebelumPageBidang}{this.state.halPageBidang.map(dt=> { return dt})}{this.state.setelahPageBidang}{this.state.akhirPageBidang}
                                                                </div>
                                                                </>
                                                              ) : (
                                                                <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                              )}
                                                            </div>
                                                          </div>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </TabPane>
                                              </TabContent>
                                            </Row>
                                          </TabPane>
                                        </>
                                      );
                                    })
                                  ) : (
                                    <>
                                      <Label
                                        className="col-sm-12 col-form-label text-center"
                                        htmlFor="inputEmail3"
                                      >
                                        {/* Data Lembaga Belum Ada */}
                                      </Label>
                                    </>
                                  )}
                                  <TabPane tabId={999998}>
                                    <Row>
                                      <Col sm="12">
                                        <div className="card mb-0">
                                            <div className="card-header">
                                              <div className="row">
                                                <div className="col-sm-12">
                                                  <h5>List Data Lembaga Kemasyarakatan {JENIS_DESA}</h5>
                                                </div>
                                                <div className="col-sm-12">&nbsp;</div>
                                                <div className="col-sm-6 text-left">
                                                  <input
                                                    type="search"
                                                    className="form-control"
                                                    id="cariTable"
                                                    placeholder="Cari Data..."
                                                    defaultValue={this.state.dataCariLembaga}
                                                    onKeyPress={this.cariDataLembaga}
                                                  />    
                                                </div>
                                                <div className="col-sm-6 text-right">
                                                  <Button
                                                    size="sm"
                                                    color="success"
                                                    onClick={() => {
                                                      this.tambahDataLembaga();
                                                    }}
                                                  >
                                                    Tambah Data
                                                  </Button>       
                                                </div>
                                              </div>
                                              <div className="col-12">
                                                &nbsp;
                                              </div>
                                              <div className="datatable-react">
                                                {this.state.loading ? (
                                                  <div className="row">
                                                    <div className="col-sm-12" align="center">
                                                      <img
                                                        alt="loading"
                                                        src={require("../../../assets/images/tes-loading.gif")}
                                                        style={{
                                                          borderRadius: "10px",
                                                          width: '100px'
                                                        }} />
                                                    </div>
                                                  </div>
                                                ) : dataLembaga.length > 0 ? (
                                                  <>
                                                  <BootstrapTable
                                                      keyField="id"
                                                      data={ dataLembaga }
                                                      columns={ columnsLembaga }
                                                      />
                                                  <div className="pull-right text-white">
                                                      {this.state.awalLembaga}{this.state.sebelumLembaga}{this.state.halLembaga.map(dtLembaga=> { return dtLembaga})}{this.state.setelahLembaga}{this.state.akhirLembaga}
                                                  </div>
                                                  </>
                                                ) : (
                                                  <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                )}
                                              </div>
                                            </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </TabPane>
                                </TabContent>
                              </div>
                              <ModalLembaga
                                data={this.state.dtLembaga}
                                isOpen={this.state.statusLembaga.form}
                                propsData={this.props}
                                setAlert={(e) => {
                                  this.setState(e)
                                }}
                                setStatusRefresh={(e) => {
                                  if (e) {
                                    this.fetch({ page: null, where: [] });
                                    this.componentDidMount();
                                  }
                                }}
                                setIsOpen={(e) => {
                                  if (!e) {
                                    this.setState({ dtLembaga: null })
                                  }
                                  this.setState({
                                    statusLembaga: {
                                      ...this.state.statusLembaga,
                                      form: e
                                    }
                                  })
                                }}
                              />

                              <ModalProfil
                                data={this.state.detailLembaga}
                                isOpen={this.state.statusProfil.form}
                                propsData={this.props}
                                setAlert={(e) => {
                                  this.setState(e)
                                }}
                                setStatusRefresh={(e) => {
                                  if (e) {
                                    this.fetch({ page: null, where: [] });
                                    this.refreshProfil(this.state.detailLembaga.uuid)
                                  }
                                }}
                                setIsOpen={(e) => {
                                  if (!e) {
                                    this.setState({ 
                                      detailLembaga: {
                                        ...this.state.detailLembaga,
                                        status:null,
                                      }
                                    })
                                  }

                                  this.setState({
                                    statusProfil: {
                                      ...this.state.statusProfil,
                                      form: e
                                    }
                                  })
                                }}
                              />
                              
                              <ModalPerangkat
                                data={this.state.dtPerangkat}
                                uuidLembaga={this.state.uuidLembaga}
                                isOpen={this.state.statusPerangkat.form}
                                propsData={this.props}
                                optionData={{
                                  frmJabatan: this.state.listJabatan,
                                  frmBidang: this.state.listBidang,
                                  jabatanStat: this.state.jabatanStat,
                                  bidangStat: this.state.bidangStat,
                                }}
                                setAlert={(e) => {
                                  this.setState(e)
                                }}
                                setStatusRefresh={(e) => {
                                  if (e) {
                                    this.fetchPerangkat(this.state.uuidLembaga, { page: null, where: [] });
                                  }
                                }}
                                setIsOpen={(e) => {
                                  if (!e) {
                                    this.setState({ 
                                      dtPerangkat: null,
                                    })
                                  }
                                  this.setState({
                                    statusPerangkat: {
                                      ...this.state.statusPerangkat,
                                      form: e
                                    }
                                  })
                                }}
                              />

                              <ModalDetailPerangkat
                                data={this.state.detailPerangkat}
                                isOpen={this.state.statusDetailPerangkat.form}
                                propsData={this.props}
                                setAlert={(e) => {
                                  this.setState(e)
                                }}
                                setStatusRefresh={(e) => {
                                  if (e) {
                                    this.fetch({ page: null, where: [] });
                                  }
                                }}
                                setIsOpen={(e) => {
                                  if (!e) {
                                    this.setState({ detailPerangkat: null })
                                  }
                                  this.setState({
                                    statusDetailPerangkat: {
                                      ...this.state.statusDetailPerangkat,
                                      form: e
                                    }
                                  })
                                }}
                              />
                              
                              <ModalJabatanPerangkat
                                data={this.state.dtJabatanPerangkat}
                                uuidLembaga={this.state.uuidLembaga}
                                isOpen={this.state.statusJabatanPerangkat.form}
                                propsData={this.props}
                                setAlert={(e) => {
                                  this.setState(e)
                                }}
                                setStatusRefresh={(e) => {
                                  if (e) {
                                    this.fetchJabatanPerangkat(this.state.uuidLembaga, { page: null, where: [] });
                                  }
                                }}
                                setIsOpen={(e) => {
                                  if (!e) {
                                    this.setState({ dtJabatanPerangkat: null })
                                  }
                                  this.setState({
                                    statusJabatanPerangkat: {
                                      ...this.state.statusJabatanPerangkat,
                                      form: e
                                    }
                                  })
                                }}
                              />

                              <ModalBidang
                                data={this.state.dtBidang}
                                uuidLembaga={this.state.uuidLembaga}
                                isOpen={this.state.statusBidang.form}
                                propsData={this.props}
                                setAlert={(e) => {
                                  this.setState(e)
                                }}
                                setStatusRefresh={(e) => {
                                  if (e) {
                                    this.fetchBidang(this.state.uuidLembaga, { page: null, where: [] });
                                  }
                                }}
                                setIsOpen={(e) => {
                                  if (!e) {
                                    this.setState({ dtBidang: null })
                                  }
                                  this.setState({
                                    statusBidang: {
                                      ...this.state.statusBidang,
                                      form: e
                                    }
                                  })
                                }}
                              />

                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
			</div>
		);
	}
}

export default BasicTable;